import React from 'react'
import styled from 'styled-components'
import PrimaryButton from 'core-system/Button/PrimaryButton'
import AddIcon from '@mui/icons-material/Add'
import { useNavigate } from 'react-router-dom'
import { Locations } from 'shared/Router/Locations'
import wordings from '../../Shared/wordings.json'
import Text from 'core-system/Text'
import { StaticAssetsUrl } from 'redux/config/services/Constants'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;
  flex-direction: column;
  gap: 2rem;
`

const NoPrograms = () => {
  const navigate = useNavigate()
  return (
    <Container>
      <img
        src={`${StaticAssetsUrl}/programs/no_programs.svg`}
        alt='No programs found'
      />
      <Text variant='body1'>{wordings.noPrograms}</Text>
      <PrimaryButton
        startIcon={<AddIcon />}
        onClick={() => navigate(Locations.Programs.Launch)}
      >
        Create New Program
      </PrimaryButton>
    </Container>
  )
}

export default NoPrograms
